import EarlyPurchase from './EarlyPurchase';

export default EarlyPurchase;
